import { RootState } from "../RootReducer";
import { IErrorSummary } from "./ActionTypes";

export const Error = (state: RootState): IErrorSummary => state.appState.errorSummary;
